module.exports = []


//////////////////
// WEBPACK FOOTER
// ./templates/zhuanti/src/config/components-test.json
// module id = 952
// module chunks = 2